
export default class ViewerQuote {
    constructor(viewer, callback) {
        /**
        * ビューア本体。 
        * @type {OpenSeadragon.Viewer}
        */
        this._viewer = viewer;

        /**
         * 登録後に呼び出すコールバック関数。 
         * @type {Function}
         */
        this._callback = callback;

        this._rect = null;
        this._selectedSize = null;

        /**
         * 画像矩形領域選択クライアント。 
         * @type {OpenSeadragon.selection}
         */
        this._selection = viewer.selection({
            showSelectionControl: false,
            allowRotation: false,
            restrictToImage: true,
            showConfirmDenyButtons: false,
            styleConfirmDenyButtons: false,
            onSelection: this._confirm.bind(this)
        });
    }

    /**
     * 引用領域の指定を確定し、パーマリンクサーバに登録します。
     * @param {OpenSeadragon.Rect} rect 引用領域情報。
     */
    _confirm(rect) {
       
        this._rect = rect;
        this._selectedSize = Math.round(this._selection.element.clientWidth) + ',' + Math.round(this._selection.element.clientHeight);

        const url = this.generateImageUrl();

        this._raiseEvent(url);
        this._selection.setState(false);
    }

    /**
     * 画像IDを取得します。
     * @return {String} 画像ID。
     */
    _getImageUrl() {
        return this._viewer.world.getItemAt(0).source['@id'];
    }

    /**
     * URLのパラメータを生成します。
     * @param {String} sizeParam サイズパラメータの文字列。
     * @param {Number} rotate 回転角。
     * @return {String} パラメータ文字列。
     */
    _generateParametor(sizeParam, rotate) {
        
        let param = Math.round(this._rect.x) + ',' + Math.round(this._rect.y) + ',' + Math.round(this._rect.width) + ',' + Math.round(this._rect.height);
        param += '/' + sizeParam;
        param += '/' + rotate + '/default.jpg';

        return param;
    }

    /**
     * コールバック関数を実行する。
     * @param {Object} eventArgs イベントの引き数。 
     */
    _raiseEvent(eventArgs) {
        if (!document.createEvent) {
            const event = new CustomEvent('confirmSelection', { detail: eventArgs });
            this._callback.call(this, event);
        }
        else {
            const event = document.createEvent('CustomEvent');
            event.initCustomEvent('confirmSelection', false, false, eventArgs);
            this._callback.call(this, event);
        }
    }

    /**
    * 引用領域の指定を確定します。
    */
    confirmSelection() {
        'use strict';

        this._selection.confirm();
    }

    /**
     * 引用領域の指定をキャンセルします。
     */
    cancelSelection() {
        'use strict';

        this._selection.cancel();
    }

    /**
     * 引用領域の指定を開始します。
     * @param {Boolean} enabled 設定する状態。
     */
    setSelectionState(enabled) {
        'use strict';

        if (enabled) {
            this._rect = null;
            this._selectedSize = null;
        }

        this._selection.setState(enabled);
    }

    /**
     * 現在、矩形領域が指定されているか判定します。
     * @return {Boolean} 矩形領域が指定されているかどうか。
     */
    isDrawing() {
        'use strict';

        return this.rect !== null;
    }

    /**
     * パーマネントサーバに登録するURLを取得します。
     * @param {Number} [size] 登録する画像の長辺の長さ。未指定の場合は矩形領域のサイズを指定する。
     * @return {String} url
     */
    generateImageUrl(size) {
        'use strict';

        const url = this._getImageUrl();
        const sizeParam = size === undefined || size === null ? this._selectedSize : '!' + size + ',' + size;

        let degrees = this._viewer.viewport.getRotation() % 360;
        if (degrees < 0) degrees += 360;

        return url + '/' + this._generateParametor(sizeParam, degrees);
    }

    /**
     * 選択した領域のサイズを取得します。。
     * @return {OpenSeadragon.Point} 選択した領域のサイズ。
     */
    getSelectionSize() {
        'use strict';

        const size = this._selectedSize.split(',');
        const width = parseInt(size[0]);
        const height = parseInt(size[1]);

        return new OpenSeadragon.Point(width, height);
    }
}